'use client';

import RouteError from '@/shared/components/error/RouteError';

/**
 * Platform Admin Error Boundary
 *
 * Catches errors that occur anywhere within the platform admin route group
 * (organizations, audit logs, guardrails, admins, etc.).
 */
export default function PlatformError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteError error={error} reset={reset} />;
}
